export default __webpack_public_path__ + "static/media/principal-banner-mobile-eng.4c4cba7e.png";